@if (!!appointment && participants$ | async; as participants) {
  <div
    class="appointment-info card active"
    [ngClass]="{
        canceled: appointment.appointmentStatus === canceledAppointment
    }"
    >
    <div class="container-fluid">
      <div class="row">
        <div
          class="col-lg-3 col-md-2 col-sm-12 d-flex flex-column no-padding"
          >
          <div class="appointment-start-time">
            <i class="fa fa-clock"></i>
            @if (isAppointmentToday) {
              <span>
                {{ "APPOINTMENT.INFO.TODAY" | translate }}
                {{ appointment.startDateTime | date : "HH:mm" }}
                {{ "APPOINTMENT.INFO.TIME-MAIN-SPECIFIER" | translate }}
              </span>
            }
            @if (!isAppointmentToday) {
              <span>
                {{
                appointment.startDateTime
                | date : "dd.LL.yyyy HH:mm"
                }}
                {{ "APPOINTMENT.INFO.TIME-MAIN-SPECIFIER" | translate }}
              </span>
            }
            <span class="appointment-start-time-duration"
              >&nbsp;{{ appointment.period }}</span
              >
            </div>
            <div class="appointment-duration">
              <span>{{ appointment.period }}</span>
            </div>
            <div class="appointment-end-time">
              <i class="fa fa-dot-circle"></i>
              {{ appointment.endDateTime | date : "HH:mm" }}
              {{ "APPOINTMENT.INFO.TIME-MAIN-SPECIFIER" | translate }}
            </div>
          </div>
          <div class="col-md-6 col-sm-12 no-padding patient-info-wrapper">
            @for (
              participant of participants
              | slice : 0 : visibleParticipants
              ; track
              participant) {
              <div
                class="participant"
                >
                <div class="patient-info mb-2 clearfix">
                  @if (
                    appointment.appointmentStatus ===
                    canceledAppointment
                    ) {
                    <span
                      class="canceled-text"
                      >{{
                      "APPOINTMENT.STATUS.CANCELED" | translate
                      }}</span
                      >
                    }
                    @if (
                      appointment.appointmentStatus !==
                      canceledAppointment
                      ) {
                      <i class="fal fa-file-user"></i>&nbsp;
                      @if (participant?.tan) {
                        <span
                          class="tan"
                          ngxClipboard
                          [cbContent]="tanLoginLink + participant.tan"
                                ngbTooltip="{{
                                    'APPOINTMENT.TAN-CREATE-SUCCESSFUL.TAN-COPIED'
                                        | translate
                                }}"
                          [autoClose]="true"
                          placement="bottom"
                          triggers="manual"
                          #tooltip="ngbTooltip"
                          (cbOnSuccess)="toggleTooltip(tooltip)"
                          >
                          {{ participant.tan }}
                        </span>
                      }
                    }
                    @if (participant?.fullName) {
                      <span
                        class="user-name bold"
                        >{{ participant.fullName }}</span
                        >
                      }
                    </div>
                    @if (participant?.birthday) {
                      <div class="patient-info">
                        <span class="label"
                          >{{
                          "APPOINTMENT.INFO.PATIENT-EMAIL-BIRTH-DATE"
                          | translate
                          }}:&nbsp;</span
                          >
                          <span>{{
                            participant?.birthday | date : "dd.MM.yyyy"
                          }}</span>
                        </div>
                      }
                      @if (participant?.email) {
                        <div class="patient-info">
                          <span class="label"
                            >{{
                            "APPOINTMENT.INFO.PATIENT-EMAIL-LABEL"
                            | translate
                            }}:</span
                            >&nbsp;
                            <a
                              href="mailto:{{ participant.email }}"
                              class="btn-link font-weight-normal"
                              >{{ participant.email }}</a
                              >
                            </div>
                          }
                        </div>
                      }
                      @if (participants.length > defaultVisibleParticipants) {
                        <div
                          class="mb-2"
                          >
                          <button
                            class="btn btn-link no-padding toggle-participants"
                            (click)="toggleParticipants(participants.length)"
                            >
                            @if (
                              visibleParticipants ===
                              defaultVisibleParticipants) {
                              {{
                              "APPOINTMENT.INFO.PATIENTS-TOGGLE-BTN-SHOW-MORE"
                              | translate
                              : {
                              numOfPart:
                              participants.length -
                              defaultVisibleParticipants
                            }
                            }}
                            <span><i class="fa fa-caret-up"></i></span>
                          } @else {
                            {{
                            "APPOINTMENT.INFO.PATIENTS-TOGGLE-BTN-SHOW-LESS"
                            | translate
                            }}
                            <span><i class="fa fa-caret-down"></i></span>
                          }
                        </button>
                      </div>
                    }
                    @if (appointment.appointmentMessage) {
                      <div class="message">
                        <span class="bold"
                          >{{
                          "APPOINTMENT.INFO.APPOINTMENT_MESSAGE" | translate
                          }}:
                        </span>
                        {{ appointment.appointmentMessage }}
                      </div>
                    }
                  </div>
                  @if (appointmentInfoType === upComingAppointmentInfoType) {
                    <div
                      class="col-lg-3 col-md-4 col-sm-12 patient-info-wrapper appointment-action-buttons"
                      >
                      <button
                        type="button"
                        id="submitButton"
                        class="btn btn-primary"
                        [class.btn-loading]="vonageLoading$ | async"
                        [disabled]="vonageLoading$ | async"
                        (click)="start()"
                        >
                        <span>
                          <i class="fa fa-caret-right"></i>
                          {{ "APPOINTMENT.INFO.START" | translate }}
                        </span>
                      </button>
                      @if (canDeleteAppointment) {
                        <button
                          class="btn btn-danger"
                          (click)="openDeleteAppointment()"
                          >
                          {{ "APPOINTMENT.BUTTON.DELETE" | translate }}
                        </button>
                      }
                    </div>
                  }
                </div>
              </div>
            </div>
          }
